export type PaidLeaveDaysByYear = {
  year: number;
  days: number;
};

const employeeFormleavesFields = [
  'leaves',
  'additional_leaves',
  'leave_days_1',
  'leave_days_2',
  'leave_days_3',
  'leave_days_4',
];

// eslint-disable-next-line import/prefer-default-export
export const getIsLeaveFieldDirty = (obj: { [key: string]: boolean }): string[] => {
  return employeeFormleavesFields.filter(f => f in obj);
};

type EventStyle = {
  status?: string;
  type?: string;
  [key: string]: any;
};

export const getEventStyleColleague = (e: EventStyle): { [key: string]: string } | undefined => {
  if (e) {
    const commonStyles = {
      display: 'inline-block',
      padding: '0 5px',
      marginBottom: '5px',
    };

    if (e?.status === 'confirmed') {
      if (e?.sub_type === 'work_from_home') {
        return {
          backgroundColor: 'rgba(255, 165, 90, 1)',
          color: '#fff',
          ...commonStyles,
        };
      }
      if (e?.sub_type === 'work_from_office') {
        return {
          backgroundColor: 'rgba(184, 86, 4, 1)',
          color: '#fff',
          ...commonStyles,
        };
      }
    }

    if (
      e?.status === 'pending' ||
      e?.status === 'signing' ||
      e?.status === 'approved' ||
      e?.status === 'initiated' ||
      e?.status === 'inprogress'
    ) {
      if (e?.sub_type === 'work_from_home') {
        return {
          backgroundColor: 'rgba(255, 165, 90, 0.2)',
          ...commonStyles,
        };
      }
      if (e?.sub_type === 'work_from_office') {
        return {
          backgroundColor: 'rgba(184, 86, 4, 0.2)',
          ...commonStyles,
        };
      }
    }

    // @ts-ignore
    if (
      e?.status === 'pending' ||
      e?.status === 'signing' ||
      e?.status === 'approved' ||
      e?.status === 'initiated' ||
      e?.status === 'inprogress'
    ) {
      return {
        // @ts-ignore
        backgroundColor: 'rgba(50, 191, 163, 0.2)',
        ...commonStyles,
      };
    }

    return {
      // @ts-ignore
      backgroundColor: 'rgba(50, 191, 163, 1)',
      // @ts-ignore
      color: '#fff',
      ...commonStyles,
    };
  }
};

export const getEventStyle = (e: EventStyle): { [key: string]: string } | undefined => {
  if (e) {
    const pendingBg = {
      paid: 'rgba(50, 191, 163, 0.2)',
      unpaid: 'rgb(43, 144, 239, 0.2)',
      sick: 'rgba(255, 184, 34, 0.2)',
      additional: 'rgba(253, 126, 20, 0.2)',
      work_from_home: 'rgba(255, 165, 90, 0.2)',
      work_from_office: 'rgba(184, 86, 4, 0.2)',
    };

    const confirmedBg = {
      paid: 'rgba(50, 191, 163, 1)',
      unpaid: 'rgb(43, 144, 239, 1)',
      sick: 'rgba(255, 184, 34, 1)',
      additional: 'rgba(253, 126, 20, 1)',
      work_from_home: 'rgba(255, 165, 90, 1)',
      work_from_office: 'rgba(184, 86, 4, 1)',
    };

    const commonStyles = {
      minWidth: '110px',
      display: 'inline-block',
      padding: '0 5px',
      marginBottom: '5px',
    };

    // @ts-ignore
    if (e?.status === 'pending' || e?.status === 'signing' || e?.status === 'approved') {
      return {
        // @ts-ignore
        backgroundColor: pendingBg[e?.type],
        ...commonStyles,
      };
    }

    // @ts-ignore
    if (e?.type === 'holiday') {
      return {
        // @ts-ignore
        fontWeight: '500',
        ...commonStyles,
      };
    }

    return {
      // @ts-ignore
      backgroundColor: confirmedBg[e?.type],
      // @ts-ignore
      color: e.event?.type === 'sick' ? undefined : '#fff',
      ...commonStyles,
    };
  }
};

export const getCalendarLegendItems = (isFeatureShowWFHLeaveTypeInMainDropdown?: boolean) => [
  {
    type: 'paid',
    backgroundColor: 'rgba(50, 191, 163, 1)',
  },
  {
    type: 'unpaid',
    backgroundColor: 'rgb(43, 144, 239, 1)',
  },
  {
    type: 'sick',
    backgroundColor: 'rgba(255, 184, 34, 1)',
  },
  {
    type: 'additional',
    backgroundColor: 'rgba(253, 126, 20, 1)',
  },
  ...(isFeatureShowWFHLeaveTypeInMainDropdown
    ? [
        {
          type: 'work_from_home',
          backgroundColor: 'rgba(255, 165, 90, 1)',
        },
        {
          type: 'work_from_office',
          backgroundColor: 'rgba(184, 86, 4, 1)',
        },
      ]
    : []),
];

export const calendarLegendItemsColleague = [
  {
    type: 'confirmed',
    backgroundColor: 'rgba(50, 191, 163, 1)',
  },
  {
    type: 'waitingForConfirmation',
    backgroundColor: 'rgba(50, 191, 163, 0.2)',
    color: '#6c757d',
  },
];

export const calendarLegendHomeOffice = [
  {
    type: 'homeConfirmed',
    sub_type: 'work_from_home',
    backgroundColor: 'rgba(255, 165, 90, 1)',
  },
  {
    type: 'waitingHomeConfirmation',
    sub_type: 'work_from_home',
    backgroundColor: 'rgba(255, 165, 90, 0.2)',
    color: '#6c757d',
  },
  {
    type: 'officeConfirmed',
    sub_type: 'work_from_office',
    backgroundColor: 'rgba(184, 86, 4, 1)',
  },
  {
    type: 'waitingOfficeConfirmation',
    sub_type: 'work_from_office',
    backgroundColor: 'rgba(184, 86, 4, 0.2)',
    color: '#6c757d',
  },
];

// This method checks if number is integer or floating point number and returns correct format, without floating point if needed.
// Ex. input = 10.5 => 10.5 //output
// Ex. input = 10.0 => 10 //output
export const isIntigerOrFloat = (number: string | number): number => {
  const num = Number(number);

  if (Number.isInteger(num)) {
    return num;
  }

  return Number(num.toFixed(1));
};

// Checks the input number and returns whole num or floating point number rounded
// to the nearest multply of 0.5
// Ex. input = 1.2 => 1 //output
// Ex. input = 1.4 => 1.5 //output
// Ex. input = 1.8 => 2 //output
export const roundToNearestHalfOrWhole = (num: number): number => {
  const decimal = num - Math.floor(num);
  if (decimal < 0.25) {
    return Math.floor(num);
  }

  if (decimal >= 0.25 && decimal < 0.75) {
    return Math.floor(num) + 0.5;
  }

  return Math.ceil(num);
};

export const setLeaveDaysValue = (
  leaveDaysArr: string[],
  isHalfDayOptionActive: boolean,
  setLeavedayValue: (val1: string, val2: number | string) => string | number
): void => {
  const regex = /[a-zA-Z]/;

  leaveDaysArr.forEach((str: string, index: number) => {
    // If the value is empty
    if (str === '') {
      return;
    }

    // If the value contains letters
    if (regex.test(str)) {
      let string = '';

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < str.length; i++) {
        const char = str.charAt(i);
        if (regex.test(char)) {
          string += '';
        } else {
          string += char;
        }
      }

      return setLeavedayValue(`leave_days_${index + 1}`, string);
    }

    // --------------- isHalfDayOptionActive ON -------------- //
    if (isHalfDayOptionActive) {
      // If the value is multiple by 0.5
      if (parseFloat(str) % 0.5 !== 0) {
        return setLeavedayValue(`leave_days_${index + 1}`, roundToNearestHalfOrWhole(parseFloat(str)));
      }

      return setLeavedayValue(`leave_days_${index + 1}`, str);
    }

    // --------------- isHalfDayOptionActive OFF -------------- //
    let newStr = str;

    // If the value contains dot or comma
    if (str.includes(',') || str.includes('.')) {
      newStr = str.replace(',', '').replace('.', '');
    }

    // If the value starts with zero
    if (str.startsWith('0')) {
      newStr = str.replace('0', '').replace('.', '');
    }

    return setLeavedayValue(`leave_days_${index + 1}`, Number(newStr));
  });
};
